import { combineReducers } from 'redux';
import { combineActions, handleActions } from 'redux-actions';
import {
  DISCARD_LOCK_FAILURE,
  DISCARD_LOCK_REQUEST,
  DISCARD_LOCK_SUCCESS,
  UNLOCK_LOCK_FAILURE,
  UNLOCK_LOCK_REQUEST,
  UNLOCK_LOCK_SUCCESS,
} from '../../../common/publish-steps/containers/publish-steps-constants';
import * as ticketActionTypes from '../../../tickets/containers/constants';
import { GET_ORDER_DETAILS_REQUEST } from '../../details/containers/details-constants';
import * as actionTypes from './parts-constants';

export const addedParts = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.ADD_PART_REQUEST,
    )]: () => [],
    [GET_ORDER_DETAILS_REQUEST]: (state, { payload }) =>
      payload?.skipLoading ? state : [],
    [actionTypes.ADD_PART_SUCCESS]: (state, { payload }) => !payload.addPartsToXml && payload.parts,
    [actionTypes.ADD_SUPERSEDED_PART]: (state, { payload }) => [payload],
  },
  [],
);

export const materials = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.SEARCH_PART_REQUEST,
      actionTypes.ADD_PART_SUCCESS,
    )]: () => [],
    [actionTypes.SEARCH_PART_SUCCESS]: (state, { payload }) => payload.items.materialNumbers,
  },
  [],
);

export const resetLogisticsDates = handleActions(
  {
    [combineActions(
      DISCARD_LOCK_FAILURE,
      DISCARD_LOCK_REQUEST,
      UNLOCK_LOCK_REQUEST,
      UNLOCK_LOCK_FAILURE,
    )]: () => false,
    [combineActions(
      DISCARD_LOCK_SUCCESS,
      UNLOCK_LOCK_SUCCESS,
    )]: () => true,
  },
  false,
);

export const logisticsDates = handleActions(
  {
    [actionTypes.GET_LOGISTICS_DATES_SUCCESS]: (state, { payload }) =>
      payload.partsLogisticsDetails,
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.GET_LOGISTICS_DATES_REQUEST,
      actionTypes.GET_LOGISTICS_DATES_FAILURE,
      GET_ORDER_DETAILS_REQUEST,
    )]: () => [],
  },
  [],
);

export const logisticsDatesLastUpdated = handleActions(
  {
    [actionTypes.GET_LOGISTICS_DATES_SUCCESS]: (state, { payload }) =>
      payload.lastUpdated,
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.GET_LOGISTICS_DATES_REQUEST,
      actionTypes.GET_LOGISTICS_DATES_FAILURE,
    )]: () => null,
  },
  null,
);

export const logisticsDatesMinutesToBeValid = handleActions(
  {
    [actionTypes.GET_LOGISTICS_DATES_SUCCESS]: (state, { payload }) =>
      payload.minutesToBeValid,
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.GET_LOGISTICS_DATES_REQUEST,
      actionTypes.GET_LOGISTICS_DATES_FAILURE,
    )]: () => 0,
  },
  0,
);

export const isSearching = handleActions(
  {
    [actionTypes.SEARCH_PART_REQUEST]: () => true,
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.SEARCH_PART_SUCCESS,
      actionTypes.SEARCH_PART_FAILURE,
    )]: () => false,
  },
  false,
);

export const isAdding = handleActions(
  {
    [actionTypes.ADD_PART_REQUEST]: () => true,
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.ADD_PART_SUCCESS,
      actionTypes.ADD_PART_FAILURE,
    )]: () => false,
  },
  false,
);

export const forceClearSearch = handleActions(
  {
    [combineActions(
      actionTypes.SEARCH_PART_SUCCESS,
      ticketActionTypes.UPDATE_PARTS,
      actionTypes.ADD_PART_SUCCESS,
      actionTypes.ADD_PART_FAILURE,
    )]: () => false,
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.ADD_PART_REQUEST,
    )]: () => true,
    [combineActions(
      ticketActionTypes.CLEAR_PART_FIELD,
    )]: (state, { payload }) => payload,
  },
  false,
);

export const addSuccess = handleActions(
  {
    [combineActions(
      actionTypes.ADD_PART_SUCCESS,
      actionTypes.ADD_SUPERSEDED_PART,
    )]: () => true,
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.ADD_PART_REQUEST,
      actionTypes.ADD_PART_FAILURE,
      actionTypes.SUCCESSFULLY_ADDED_SUPERSEDED_PART,
    )]: () => false,
  },
  false,
);

export default combineReducers({
  addedParts,
  materials,
  logisticsDates,
  resetLogisticsDates,
  logisticsDatesLastUpdated,
  logisticsDatesMinutesToBeValid,
  addSuccess,
  isSearching,
  isAdding,
  forceClearSearch,
});
